{
    "monster": {
        "key": "monster",
        "jobKey": "book/undead",
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        }
    },
    "54Ft8": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "54Ft8"
    },
    "ashe": {
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    },
    "UCUMK": {
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "UCUMK"
    },
    "VIZC3": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/ember/torch",
        "jobKey": "book/terrain",
        "key": "VIZC3"
    },
    "2fktB": {
        "key": "2fktB",
        "jobKey": "book/undead",
        "position": {
            "x": 6,
            "y": 9,
            "z": 1
        }
    },
    "page": {
        "key": "page",
        "role": "page",
        "spriteSize": "contained", "imageKey": "book/page3",
        "type": "zone",
        "properties": [
            "no healthbar"
        ],
        "position": {
            "x": 4,
            "y": 5,
            "z": 1
        },
        "pageKeys": [
            "undead"
        ]
    }
}
